<template>
  <v-select
    :value="value"
    :label="label"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :disabled="!items.length"
    :error-messages="errors.collect(label)"
    @input="onInput"
  ></v-select>
</template>

<script>
export default {
  $_veeValidate: {
    name() {
      return this.label;
    }
  },
  inject: {
    $validator: "$validator"
  },
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    itemText: {
      type: String,
      default: "text"
    },
    itemValue: {
      type: String,
      default: "value"
    }
  },
  methods: {
    onInput(input) {
      const item = this.items.find(element => {
        return element.value == input;
      });
      this.$emit("input", item);
    }
  },
  mounted() {
    if (this.items && this.items.length == 1) {
      this.$emit("input", this.items[0]);
    }
  }
};
</script>
